import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sidebar", "main", "overlay", "bar1", "bar2", "bar3"]

  toggle() {
    if (this.sidebarTarget.classList.contains("max-lg:-translate-x-full")) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    this.sidebarTarget.classList.remove("max-lg:-translate-x-full")
    this.overlayTarget.classList.remove("opacity-0", "pointer-events-none")
    this.overlayTarget.classList.add("opacity-30")
    
    // Transition hamburger into X
    this.bar1Target.classList.add("rotate-45", "translate-y-1.5")
    this.bar2Target.classList.add("opacity-0")
    this.bar3Target.classList.add("-rotate-45", "-translate-y-1.5")
  }

  close() {
    this.sidebarTarget.classList.add("max-lg:-translate-x-full")
    this.overlayTarget.classList.add("opacity-0", "pointer-events-none")
    this.overlayTarget.classList.remove("opacity-30")
    
    // Revert X back to hamburger
    this.bar1Target.classList.remove("rotate-45", "translate-y-1.5")
    this.bar2Target.classList.remove("opacity-0")
    this.bar3Target.classList.remove("-rotate-45", "-translate-y-1.5")
  }
}